// Bundled configuration replaces the retired external configuration service.
// Preserve the previous defaults used when that service was unavailable.
// These flags control UI availability only; they are not an authorization policy.
export const DMA_DASHBOARD_CONFIG = {
  wheel: true,
  withdraw: { usdt: true, des: true },
  network: { eth: true, bsc: true }
};

// Verbatim local notice from LoyaltyProgram/index.js at bbd177f.
// The retired remote FAQ could not be recovered; use the existing local copy.
export const LOYALTY_PROGRAM_NOTICE =
  "Thanks to the participation and feedback from Delysium members, the Loyalty Program Beta has been turned into an update on 8/16/2023. Loyalty Score is no longer associated with any direct rewards and is only used to record and evaluate user activity and engagement. Stay active, engage more with the content and experiences in the Delysium ecosystem, and become a more loyal member!";

export const LOYALTY_FAQS = [
  { title: "Loyalty Program", content: LOYALTY_PROGRAM_NOTICE }
];
